(function ($, root, undefined) {
	
	$(function () {
		
		//Mobile menu	
		$(function() {
			var burger		= $('#hamburger-menu');
			menu 		= $('nav .menu');
			menuHeight	= menu.height();
	
			$(burger).on('click', function(e) {
				e.preventDefault();
				menu.slideToggle();
			});
		});
		$(window).resize(function(){
			var w = $(window).width();
	                        
	        if(typeof menu !== 'undefined') {
				if(w > 767 && menu.is(':hidden')) {
					menu.removeAttr('style');
	            }
			}
		});
		
		//Hamburger close icon
		$(function() {
		    var anchor = document.querySelectorAll('button');
		    
		    [].forEach.call(anchor, function(anchor){
		    	var open = false;
				anchor.onclick = function(event){
		        	event.preventDefault();
					if(!open){
						this.classList.add('close');
						open = true;
					}
					else {
			        	this.classList.remove('close');
						open = false;
		        	}
		    	}
		    });
		});
		
		$(document).ready(function(){       
            var scroll_pos = 0;
            var $hamburger = document.getElementById('hamburger');
            var isWhite = $hamburger.classList.contains('white');
            $(document).scroll(function() { 
                scroll_pos = $(this).scrollTop();
                if(scroll_pos > ($(window).height())*0.78) {
	                $hamburger.className = (isWhite ? 'lines black' : 'lines black');
                } else {
                    $hamburger.className = (isWhite ? 'lines white' : 'lines black');
                }
            });
        });
        
        $(document).ready(function() {
	        $('.gallery').magnificPopup({
			  delegate: 'a', // child items selector, by clicking on it popup will open
			  type: 'image',
			  gallery:{enabled:true}
			});
		});
		
	});
	
})(jQuery, this);
